module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/basic-colored-buttons/basic-colored-buttons.component.scss
// module id = ./src/app/features/buttons/basic-colored-buttons/basic-colored-buttons.component.scss
// module chunks = main